import {
  admissionOnlyWorkflowOption,
  mapTemplateWorkflowTypesToOptions,
} from "../atoms/start-workflow/workflowMapping";
import {WorkflowOption} from "../atoms/start-workflow/types";

import {DocumentService} from "./DocumentService";

type TemplateVersionResponse = Readonly<{
  workflowTypes?: ReadonlyArray<string>;
}>;

/**
 * Response shape for facility workflows derived from the latest template version.
 */
export type FacilityWorkflowsResponse = Readonly<{
  workflows: ReadonlyArray<WorkflowOption>;
}>;

export const WorkflowService = {
  /**
   * Fetches workflow types enabled for a facility.
   *
   * When `templateId` is given, workflows are read from that exact template version
   * (e.g. the version an existing admission was created from) instead of the facility's
   * current template — the facility's template can be replaced after an admission is
   * created, so "current" may no longer match what that admission actually supports.
   */
  async getFacilityWorkflows(
    facilityId: string,
    templateId?: string,
  ): Promise<FacilityWorkflowsResponse> {
    if (!facilityId) {
      return {workflows: [admissionOnlyWorkflowOption()]};
    }

    const {data: version} = templateId
      ? await DocumentService.getTemplateVersion(facilityId, templateId)
      : await DocumentService.getLatestTemplateVersion(facilityId);

    const workflowTypes =
      (version as TemplateVersionResponse).workflowTypes ?? [];

    return {
      workflows: mapTemplateWorkflowTypesToOptions(workflowTypes),
    };
  },
};
